import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/handcarry/`;

const registerHandCarryList = async (formData) => {
  return await axios.post(API_URL + "register", formData);
};

const getHandCarryLists = async (shopName) => {
  const params = shopName ? { shop: shopName } : {};
  return await axios.get(API_URL, { params });
};

const deleteHandCarryList = async (id) => {
  return await axios.delete(API_URL + id);
};

const checkHandCarryByUrl = async (url) => {
  return await axios.post(`${API_URL}/check`, { url });
};

// New functions
const updateJpArriveDate = async (id, data) => {
  return await axios.put(`${API_URL}/${id}/jp-arrive-date`, data);
};

const updateHandCarryDate = async (id) => {
  return await axios.put(`${API_URL}/${id}/hand-carry-date`);
};

// Expert admin functions
const getHandCarryItemsWithoutTypes = async (showAll = false) => {
  return await axios.get(`${API_URL}without-types`, { params: { showAll } });
};

const getHandCarryAirItems = async (id) => {
  return await axios.get(`${API_URL}${id}/air-items`);
};

const assignTypesToHandCarry = async (id, items) => {
  return await axios.post(`${API_URL}${id}/assign-types`, { items });
};

const assignTypesToHandCarryByOrderId = async (orderId, items) => {
  return await axios.post(`${API_URL}assign-types-by-order`, { orderId, items });
};

export default {
  getHandCarryLists,
  registerHandCarryList,
  deleteHandCarryList,
  checkHandCarryByUrl,
  updateJpArriveDate,
  updateHandCarryDate,
  getHandCarryItemsWithoutTypes,
  getHandCarryAirItems,
  assignTypesToHandCarry,
  assignTypesToHandCarryByOrderId,
};
